import React, {useCallback, useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'

import {Tag, TagSize} from '@vio/atlas/Tag'
import {Tooltip, TooltipPlacement} from '@vio/atlas/Tooltip'
import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {FREEZABLE_DEAL_TAG} from './constants'
import {dealFreezeOfferBoxMessages} from './messages'

interface Props {
  size?: TagSize
  withTooltip?: boolean
  onDisplayed?: () => void
  onClick?: () => void
  onTooltipOpen?: () => void
}

const Wrapper = styled.div`
  display: inline-flex;
`

export const FreezableDealTag = ({
  size = 'sm',
  withTooltip = false,
  onDisplayed,
  onClick,
  onTooltipOpen
}: Props) => {
  const {formatMessage} = useIntl()
  const {ref, inView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
    skip: !onDisplayed
  })

  useEffect(() => {
    if (inView) onDisplayed?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView])

  // onRender fires once per open, but again whenever its identity changes
  const onTooltipOpenRef = useRef(onTooltipOpen)
  onTooltipOpenRef.current = onTooltipOpen
  const handleTooltipRender = useCallback(
    () => onTooltipOpenRef.current?.(),
    []
  )

  const tag = (
    <Tag variant="brand" size={size} dataId={FREEZABLE_DEAL_TAG}>
      <FormattedMessageWrapper {...dealFreezeOfferBoxMessages.freezableDeal} />
    </Tag>
  )

  return (
    <Wrapper ref={ref} onClick={onClick}>
      {withTooltip ? (
        <Tooltip
          title={formatMessage(dealFreezeOfferBoxMessages.title)}
          content={
            <FormattedMessageWrapper
              {...dealFreezeOfferBoxMessages.description}
            />
          }
          placement={TooltipPlacement.Top}
          onRender={handleTooltipRender}
        >
          {tag}
        </Tooltip>
      ) : (
        tag
      )}
    </Wrapper>
  )
}
